import { axiosApi } from "../../../../../api/dbAxios";
import { INewNotification } from "../interfaces/notification.interface";

export const createNotitfaction = async (notif: INewNotification) => {
  try {
    const response = await axiosApi.post(`/notifications/`, notif);
    return response.data;
  } catch (error: any) {
    throw error.response.data.team_id[0];
  }
};
